import React, { memo } from "react";
import { AppWrapper } from "../styles/3D/styles";
import ThreeJsScene from "./scene";

const ThreeJsComponent = ({
  datoContentData,
  zoomingAnimation,
  planesAnimating,
  handleSetPlanesAnimating,
  scrollReady,
  lenisRef,
  cameraRef,
  planesRef,
  sceneRef,
}) => {
  return (
    <>
      <AppWrapper className="trident-container">
        <ThreeJsScene
          content={datoContentData}
          zoomingAnimation={zoomingAnimation}
          planesAnimating={planesAnimating}
          handleSetPlanesAnimating={handleSetPlanesAnimating}
          cameraRef={cameraRef}
          planesRef={planesRef}
          landingSceneRef={sceneRef}
          scrollReady={scrollReady}
          lenisRef={lenisRef}
        />
      </AppWrapper>
    </>
  );
};
export default memo(ThreeJsComponent);
